import { Component } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EnableInternalLogsResponse, LogsService } from '@api/service/logs.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { finalize } from 'rxjs/operators';

/**
 * Modal para habilitar logs internos de debug via endpoint de suporte.
 *
 * @example
 * // Aberto a partir do HomeComponent com NzModalService.create(...)
 * // preenchendo level/http/ttl e confirmando para disparar GET.
 */
@Component({
  selector: 'app-modal-enable-logs',
  templateUrl: './modal-enable-logs.component.html',
  styleUrls: ['./modal-enable-logs.component.scss']
})
export class ModalEnableLogsComponent {
  public isSubmitting = false;
  public form: UntypedFormGroup;
  public enableLogsResponse: EnableInternalLogsResponse | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private logsService: LogsService,
    private notification: NzNotificationService,
    private modalService: NzModalService
  ) {
    this.form = this.formBuilder.group({
      level: ['debug', Validators.required],
      http: [true, Validators.required],
      ttl: [500, [Validators.required, Validators.min(1)]]
    });
  }

  /**
   * Envia a configuração para habilitar logs.
   *
   * @returns void
   * @throws Exibe notificação de erro caso a API retorne falha.
   * @example
   * component.submit();
   */
  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { level, http, ttl } = this.form.value;
    this.isSubmitting = true;
    this.enableLogsResponse = null;

    this.logsService
      .enableInternalLogs({
        level: String(level),
        http: Boolean(http),
        ttl: Number(ttl)
      })
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: response => {
          this.enableLogsResponse = response;
          this.notification.create('success', 'Logs habilitados', 'Configuração aplicada com sucesso.');
        },
        error: error => {
          const errorMessage = error?.error?.error || error?.error?.message || 'Não foi possível habilitar os logs.';
          this.notification.create('error', 'Falha ao habilitar logs', errorMessage);
        }
      });
  }

  /**
   * Fecha o modal atual.
   *
   * @returns void
   * @example
   * component.closeModal();
   */
  public closeModal(): void {
    this.modalService.closeAll();
  }
}
